import { CHANGE_THEME } from './configuration/actions';

export default (previousState = (localStorage.getItem('theme')) ? localStorage.getItem('theme') : 'light', { type, payload }) => {
    if (type === CHANGE_THEME) {
        return payload;
    }
    return previousState;
};
